import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { Card, CardBody, CardFooter } from '@react/react-spectrum/Card'
import _ from 'lodash'
import Well from '@react/react-spectrum/Well'
import Heading from '@react/react-spectrum/Heading'
import CountUp from 'react-countup'
import 'react-circular-progressbar/dist/styles.css'
import VisibilitySensor from 'react-visibility-sensor'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'

import { RootContext } from '../../../root/RootContext'
import { ProfileContext } from '../../../root/ProfileContext'
import { getProfileFieldValue } from '../../../config/lib.js'
import './CustomerAI.scss'

export default function CustomerAI({ meta, content }) {
  const profileContext = useContext(ProfileContext)
  const rootContext = useContext(RootContext)
  const currentProfile = profileContext.state.currentProfile
  const tenantId = '_' + rootContext?.project?.integrations?.aep?.imsOrg?.tenantID

  const components = {
    CircularKPI: CircularKPI,
    KPI: KPI,
  }

  return (
    <div className='profile-module customerai-summary'>
      <div className='module-content'>
        {currentProfile && currentProfile.experienceEvents && (
          <>
            {content.description && <Well>{content.description}</Well>}
            {content.scores
              // .sort((a, b) => (a.meta.order > b.meta.order ? 1 : -1))
              .map((score, index) => {
                let s = { ...score }
                //only circular supported for now in argon
                //let Component = components[s.meta.component]

                //if ee. prefix, look at experience event instead of profile data
                if (s.attribute.startsWith('ee.')) {
                  const attribute = s.attribute.substring(3).replace('$tenantId', tenantId)
                  const d = s.description.substring(3).replace('$tenantId', tenantId)
                  //keep most recent EE matchinng the attribute path
                  let ee = _.filter(currentProfile.experienceEvents, (e) => _.get(e, attribute)).sort(
                    (a, b) => b.timestamp - a.timestamp
                  )
                  s.score = _.get(ee[0], attribute)

                  //look for description attribute path in most recent EE
                  const descValue = _.get(ee[0], d)
                  s.description = descValue ? descValue : s.description

                  // look at profile attribute
                } else {
                  if (isNaN(s.attribute)) {
                    s.score = parseFloat(getProfileFieldValue(tenantId, currentProfile, s.attribute))
                  } else {
                    s.score = s.attribute
                  }

                  //check if description path corresponds to a profile attribute
                  const descValue = getProfileFieldValue(tenantId, currentProfile, s.description)
                  s.description = descValue.startsWith('--') ? s.description : descValue
                }

                const ts = new Date(s.description)
                if (ts.toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' }) != 'Invalid Date') {
                  s.description = ts.toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })
                }
                let Component = components['CircularKPI']
                return <Component key={index} {...s} />
              })}
          </>
        )}
      </div>
    </div>
  )

  /* colors from customer AI
    Low propensity: rgb(227, 72, 80);
    Medium propensity 25 to 74 : rgb(250, 185, 10);
    High propensity 75 and above:  rgb(45, 157, 120);
  */
  function CircularKPI({ title, risk, score, description }) {
    //display all score from 1 to 100
    score = score <= 1 ? Math.round(score * 100) : score
    let c
    if (risk === 'red') {
      c = score < 25 ? 'rgb(45, 157, 120)' : score < 75 ? 'rgb(250, 185, 10)' : 'rgb(227, 72, 80)'
    } else {
      c = score < 25 ? 'rgb(227, 72, 80)' : score < 75 ? 'rgb(250, 185, 10)' : 'rgb(45, 157, 120)'
    }

    return (
      <Card allowsSelection={false} className='kpi-entry'>
        <CardBody>
          <div className='kpi-value' style={{ width: 190 }}>
            <VisibilitySensor>
              {({ isVisible }) => {
                const v = isVisible ? score : 0
                return (
                  <CircularProgressbar
                    strokeWidth='6'
                    value={v}
                    text={`${score || 'N/A'}`}
                    styles={buildStyles({
                      textColor: 'rgb(51, 51, 51)',
                      pathColor: c,
                      textSize: '40px',
                      fontWeight: '400',
                      pathTransitionDuration: 0.9,
                    })}
                  />
                )
              }}
            </VisibilitySensor>
          </div>
          <div className='kpi-label' style={{ paddingTop: 10 }}>
            {title.toUpperCase()}
          </div>
        </CardBody>
        <CardFooter>
          <span className={'cardFooter-center'}>
            <small>{description}</small>
          </span>
        </CardFooter>
      </Card>
    )
  }

  function KPI({ value, label, suffix, risk }) {
    return (
      <Card allowsSelection={false} className='kpi-entry'>
        <CardBody>
          <div className='kpi-value'>
            <CountUp start={0} end={value} duration={10} separator=',' suffix={suffix} />
          </div>
          <div className='kpi-label'>{label}</div>
        </CardBody>
      </Card>
    )
  }
}

CustomerAI.requiresLaunch = false
